/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_GetInputs */

const en_pc_dl_get = /** @type {(inputs: Pc_Dl_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const zh_pc_dl_get = /** @type {(inputs: Pc_Dl_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Pc_Dl_GetInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_get = /** @type {((inputs?: Pc_Dl_GetInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_GetInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_get(inputs)
	return zh_pc_dl_get(inputs)
});
export { pc_dl_get as "pc.dl.get" }